import type { Plan } from '@ecomm/maps/types/Plan'
import type { HybridPlanData } from '../../../../data/expandablePlanCardData'
import { hybridPlanData as planData } from '../../../../data/expandablePlanCardData'

const pricePerDayContent = (pricePerDay: string) => (
  <div className="text-left flex flex-row items-center">
    <span className="font-arizona text-complementary-red-100 text-4xl font-bold mr-1">
      {pricePerDay}
    </span>
    <span>/day</span>
  </div>
)

const descriptionContent = (sku: string, planData: HybridPlanData) => {
  const descriptionData = planData?.[sku]?.description
  return <p className="text-sm md:text-base m-0">{descriptionData}</p>
}

const featuresContent = (sku: string, planData: HybridPlanData) =>
  planData?.[sku]?.features

/**
 * Retrieves card data for a given plan, including daily price, description, badge, features, name and sku.
 *
 * @param plan - The plan object containing details like SKU and daily price.
 * @returns An object containing formatted daily price, description, and features for the card.
 */
export const getCardData = (plan: Plan) => {
  const sku = plan.sku
  const pricePerDay = plan.pricePerDay
  const planName = plan.shortName

  return {
    badge: planData?.[sku]?.badge,
    pricePerDay: pricePerDayContent(pricePerDay),
    description: descriptionContent(sku, planData),
    features: featuresContent(sku, planData),
    name: planName,
    sku: sku
  }
}
